// <auto-generated />
// assembly: SecureTokenService.Generator.TypeScript, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
// generator: SecureTokenService.Generator.TypeScript.VariablesSourceGenerator

export const Variables = {
    ApiBaseUrl: 'https://sso.panamadigital.gob.pa/SecurityTokenService',
    PublicPath: 'SecurityTokenService/',
    PanamaDigitalPath: 'https://www.panamadigital.gob.pa/',
    SitekeyRecaptcha: '6LeqgKsnAAAAAGpyqqrFrIwk-nbLEQoJrIt-WhU4',
    FileAssets: '/',
    Title: '2020 - Panamá Digital',
};